import { Deserializable } from '../../protocols/deserializable';
import { Address } from './address';
import { MemberPersonalInformation } from './member-personal-information';
import { ContactInfo } from './contact-info';
import { MemberRecordComment } from '../../../views/records/components/members/ip-view-member-record/components/ip-member-record-comments/ip-member-record-comment';
import { MostRecentInvite } from './most-recent-invite';
import { MemberRelationshipStatus } from './member-relationship-status';
import { EmploymentHistory } from './employment-history';
import { Spouse } from './spouse';
import { BankAccount } from '../../../views/banking/models/bank-account';
import { Fiduciary } from '../../../views/fiduciaries/models/fiduciary';
import { MemberStatusType } from './member-status-type';
import { MemberStatusTypeEnum } from '../enum/member-status-type-enum';
import { StatusPill } from '../../shared/status-pill';
import { MemberStatusUtils } from '../../../utils/member-status-utils';
import { IdentityTypeEnum } from '../enum/identity-type-enum';

export class MemberRecord implements Deserializable {
  public id!: number;
  public firstName!: string;
  public middleName!: string;
  public lastName!: string;
  public preferredName!: string;
  public email!: string;
  public lastLoginDate!: string;
  public portalAccessRestricted!: boolean;
  public portalAccessRestrictedDate!: string | null;
  public portalAccessRestrictedByName!: string | null;
  public allowThirdPartyContributions!: boolean;
  public statusId!: MemberStatusTypeEnum;
  public identityTypeId!: IdentityTypeEnum;
  // Everything below is expandable
  public status!: MemberStatusType;
  public address!: Address;
  public personalDetails!: MemberPersonalInformation;
  public phoneNumber!: ContactInfo;
  public spouses!: Spouse[];
  // If no relationship status is set, null is returned
  public activeRelationshipStatus!: MemberRelationshipStatus | null;
  public comments!: MemberRecordComment[];
  public mostRecentInvite!: MostRecentInvite;
  // If no past relationship statuses, empty array is returned
  public pastRelationshipStatuses!: MemberRelationshipStatus[] | [];
  public employmentHistory!: EmploymentHistory[];
  public bankAccounts!: BankAccount[];
  public activeLegalFiduciary!: Fiduciary | null;
  public pastLegalFiduciaries!: Fiduciary[] | null;

  // Not From API
  public fullName!: string;
  public displayableId!: string;
  public statusPill!: StatusPill;
  public isNonMember!: boolean;

  onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;
    this.fullName = `${this?.firstName} ${this?.lastName}`.trim();
    if (!!this.status) {
      this.status = Deserialize?.instanceOf(MemberStatusType, this.status);
    }
    this.statusPill = MemberStatusUtils.statusPill(this.statusId);
    this.isNonMember = this.identityTypeId === IdentityTypeEnum.NonMember;
    if (!!this.address) {
      this.address = Deserialize?.instanceOf(Address, this.address);
    }
    if (!!this.personalDetails) {
      this.personalDetails = Deserialize?.instanceOf(MemberPersonalInformation, this.personalDetails);
    }
    if (!!this.phoneNumber) {
      this.phoneNumber = Deserialize?.instanceOf(ContactInfo, this.phoneNumber);
    }
    if (!!this.comments) {
      this.comments = Deserialize?.arrayOf(MemberRecordComment, this.comments);
    }
    if (!!this.mostRecentInvite) {
      this.mostRecentInvite = window?.injector?.Deserialize?.instanceOf(MostRecentInvite, this.mostRecentInvite);
    }
    if (!!this.activeRelationshipStatus) {
      this.activeRelationshipStatus = Deserialize?.instanceOf(MemberRelationshipStatus, this.activeRelationshipStatus);
    }
    if (!!this.pastRelationshipStatuses) {
      this.pastRelationshipStatuses = Deserialize?.arrayOf(MemberRelationshipStatus, this.pastRelationshipStatuses);
    }
    if (!!this.spouses) {
      this.spouses = Deserialize?.arrayOf(Spouse, this.spouses);
    }
    if (!!this.bankAccounts) {
      this.bankAccounts = Deserialize?.arrayOf(BankAccount, this.bankAccounts);
    }
    if (!!this.activeLegalFiduciary) {
      this.activeLegalFiduciary = Deserialize?.instanceOf(Fiduciary, this.activeLegalFiduciary);
    }
    if (!!this.pastLegalFiduciaries) {
      this.pastLegalFiduciaries = Deserialize?.arrayOf(Fiduciary, this.pastLegalFiduciaries);
    }

    this.displayableId = this.id.toString().padStart(8, '0');
  }
}
